// theme.j
// TODO: Move theming logic to common
import { createTheme, useMediaQuery } from "@mui/material";

// Base theme configuration
const baseTheme = (mode) =>
  createTheme({
    typography: {
      fontFamily: "'Poppins', sans-serif",
      fontSize: 14,
      h1: { fontSize: "2rem" },
      h2: { fontSize: "1.75rem" },
      h3: { fontSize: "1.5rem" },
      h4: { fontSize: "1.25rem" },
      h5: { fontSize: "1rem" },
      body1: { fontSize: "1rem" },
      body2: { fontSize: "0.875rem" },
      subTitle1: { fontSize: "0.9rem" },
    },
    palette: {
      mode,
      primary: {
        main: mode === "dark" ? "#35BD5B" : "#35BD5B",
      },
      secondary: {
        main: mode === "dark" ? "#1E1E1E" : "#F0F4F8",
      },
      text: {
        primary: mode === "dark" ? "#FFFFFF" : "#05160A",
        secondary: mode === "dark" ? "#FFFFFF" : "#05160A",
      },
      background: {
        default: mode === "dark" ? "#121212" : "#FFFFFF",
        paper: mode === "dark" ? "#1E1E1E" : "#FFFFFF",
        bookies: mode === "dark" ? "#1E1E1E" : "#F0F0F0",
      },
      eventBackground: {
        main: mode === "dark" ? "#333333" : "#F0F0F0",
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            color: mode === "dark" ? "#FFFFFF" : "#05160A",
            "&:hover": {
              backgroundColor: mode === "dark" ? "#333333" : "#E0E4E8",
            },
          },
          outlined: {
            borderColor: mode === "dark" ? "#FFFFFF" : "#05160A",
            color: mode === "dark" ? "#FFFFFF" : "#05160A",
            "&:hover": {
              backgroundColor:
                mode === "dark"
                  ? "rgba(255, 255, 255, 0.1)"
                  : "rgba(5, 22, 10, 0.1)",
              borderColor: mode === "dark" ? "#E0E0E0" : "#333333",
            },
          },
          text: {
            color: mode === "dark" ? "#FFFFFF" : "#05160A",
            "&:hover": {
              backgroundColor:
                mode === "dark"
                  ? "rgba(255, 255, 255, 0.1)"
                  : "rgba(5, 22, 10, 0.1)",
            },
          },
        },
      },
    },
  });

// Function to adjust typography for mobile
const getMobileTypography = (theme) => {
  const scale = 0.7;
  return Object.keys(theme.typography).reduce((acc, key) => {
    const style = theme.typography[key];
    if (typeof style === "object" && style.fontSize) {
      const originalSize = style.fontSize;
      const adjustedSize = `calc(${originalSize} * ${scale})`;
      acc[key] = { ...style, fontSize: adjustedSize };
    }
    return acc;
  }, {});
};

export const useResponsiveTheme = (mode) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  return createTheme({
    ...baseTheme(mode),
    ...(isMobile && { typography: getMobileTypography(baseTheme(mode)) }),
  });
};
